/*登录,注册,退出请求*/
const axios = require('axios')
const qs = require('qs')
const {LOGIN_URL,REGISTER_URL,LOGOUT_URL} = require('./url')

/*登录请求*/
function login({username,password}){
  return new Promise((resolve, reject) => {
      axios.post(LOGIN_URL, qs.stringify({
          username,password
      }))
          .then(res => {
              //console.log(res);
              resolve(res.data)
          })
          .catch(err =>{
              reject(err)
          })
  })
}

/*注册请求*/
function register({password, role, username}){
    return new Promise((resolve, reject) => {
        axios.post(REGISTER_URL, {
            password, role, username
        })
            .then(function (response) {
               // console.log(response.data);
                resolve(response.data)
            })
            .catch(function (error) {
               // console.log(error);
                reject(error)
            })
    })
}

/*退出登录请求*/
function logout(){
   return new Promise((resolve,reject) => {
       axios.get(LOGOUT_URL)
           .then(function (response) {
               resolve(response)
           })
           .catch(function (error) {
               reject(error)
           });
   })
}

/*添加axios请求拦截,在请求头中添加token*/
function axiosStop(){
   // console.log("helloworld");
    axios.interceptors.request.use(config=>{
       config.headers.Authorization = window.sessionStorage.getItem('token')
        //config.headers.Authorization = 'Bearer ' + window.sessionStorage.getItem('token')
        // console.log(config.headers.Authorization);
        return config
    })
}
module.exports = {
    login,
    register,
    logout,
    axiosStop
}
